export default "__VITE_ASSET__DzQhr_fI__"